<template>
  <transition name="fade" mode="out-in" appear>
    <VSpinner v-if="isLoading" class="offset-top-2 offset-bottom-6" />
    <article v-else id="INTERNAL_STOCK">
      <div class="container-fluid grayed-offset offset-top-3">
        <div class="container-fixed">
          <VGrid
            :items="bookedSubscriptions"
            :has-any-promo="hasAnyPromo(bookedSubscriptions)"
            @update:instance="onUpdateInstance('bookedSubscriptions', $event)"
          >
            <template #label>
              {{ $t('internalstock.booked_subscriptions_headline') }}
              <!-- #S818 -->
            </template>
            <template #item="{ item }">
              <VInternalStockItem :item="item" />
            </template>
            <template #empty>
              <div class="h-ctr v-ctr offset-top-3 offset-bottom-3">
                {{ $t('internalstock.empty_subscriptions') }}
              </div>
            </template>
          </VGrid>

          <VGrid :items="cancelledSubscriptions" :has-any-promo="hasAnyPromo(cancelledSubscriptions)" data-test="cancelledSubscriptions">
            <template #label>
              {{ $t('internalstock.terminated_subscriptions_headline') }}
              <!-- #S860 -->
            </template>
            <template #item="{ item }">
              <VInternalStockItem :item="item" />
            </template>
            <template #empty>
              <div class="h-ctr v-ctr offset-top-3 offset-bottom-3">
                {{ $t('internalstock.empty_subscriptions') }}
              </div>
            </template>
          </VGrid>
        </div>
      </div>
    </article>
  </transition>
</template>

<script>
import VSpinner from '@/components/Spinner';
import TitleMixin from '@/mixins/title';
import Proxy from '@/proxies/SubstoreInternalStockProxy';
import VGrid from '@/components/Substore/StockGrid';
import VInternalStockItem from '@/components/Substore/InternalStock/Item';

export default {
  name: 'InternalStock',

  components: {
    VSpinner,
    VGrid,
    VInternalStockItem,
  },

  mixins: [TitleMixin],

  data() {
    return {
      isLoading: true,
      bookedSubscriptions: null,
      cancelledSubscriptions: null,
    };
  },

  async created() {
    const response = await new Proxy().all();
    if (response.head.fault !== null) throw new Error(response.head.fault);

    this.bookedSubscriptions = response.data.bookedSubscriptions;
    this.cancelledSubscriptions = response.data.cancelledSubscriptions;
    this.isLoading = false;
  },

  methods: {
    onUpdateInstance(key, instance) {
      const items = this[key];
      for (const item of items) {
        const index = item.instances.findIndex(i => i.id === instance.id);
        if (index !== -1) {
          this.$set(item.instances, index, instance);
          break;
        }
      }
    },

    hasAnyPromo(items) {
      return items.some(s => s.instances.some(i => i.promotionEnd));
    },
  },
};
</script>
